import {AdGroupBean} from 'common/api/api'
import {FC} from 'react'
import {DictionarySelector, DictionarySelectorProps, enumToLabelValue} from './DictionarySelector'
import BrowsersEnum = AdGroupBean.BrowsersEnum

export const BrowserSelector: FC<DictionarySelectorProps> = (props) =>
    <DictionarySelector {...props} cacheKey="browser" loader={() => enumToLabelValue(BrowsersEnum)} mode="multiple"/>